<template>
  <div ref="canvas" :style="styleObj"></div>
</template>

<script>
import echarts from 'echarts' // 4.9.0

export default {
  name: 'EchartsMixed',
  props: {
    option: { type: Object, required: true },
    height: { type: [Number, String], default: 400 },
    width:  { type: [Number, String], default: '100%' },
    // 可以是字串（已註冊的主題名）或直接傳 object（ECharts 4 也支援）
    theme:  { type: [String, Object], default: null },
  },
  data: () => ({ chart: null }),
  computed: {
    styleObj() {
      const h = typeof this.height === 'number' ? `${this.height}px` : this.height;
      const w = typeof this.width  === 'number' ? `${this.width}px` : this.width;
      return { height: h, width: w };
    }
  },
  mounted() { this.initAndRender(); window.addEventListener('resize', this.onResize); },
  beforeDestroy() { window.removeEventListener('resize', this.onResize); this.dispose(); },
  watch: {
    option: { deep: true, handler() { this.chart && this.chart.setOption(this.option, true); } },
    height() { this.$nextTick(this.onResize); },
    width()  { this.$nextTick(this.onResize); },
    theme:   { deep: true, handler() { this.initAndRender(); } }, // ← 主題變更要重建
  },
  methods: {
    dispose() { if (this.chart) { this.chart.dispose(); this.chart = null; } },
    initAndRender() {
      this.dispose();
      this.chart = echarts.init(this.$refs.canvas, this.theme || undefined);
      this.chart.setOption(this.option, true);
      this.onResize();
    },
    onResize() { this.chart && this.chart.resize(); },
  }
}
</script>

